module.exports = "<svg id=\"be5a67dc-6975-4898-83a6-26ae5fb8a491\" data-name=\"Capa 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 298.6 512\"><defs><style>.\\36 de6fa58-1ccf-42c3-8c4f-726408657dc8{fill:#d7ed00;}</style></defs><title>slider-prev</title><path class=\"6de6fa58-1ccf-42c3-8c4f-726408657dc8\" d=\"M198.5,256,400.2,54.4a16.2,16.2,0,0,0,0-23.6L374.5,5.1a16.2,16.2,0,0,0-23.6,0L111.8,244.2a16.2,16.2,0,0,0,0,23.6L350.9,506.9a16.2,16.2,0,0,0,23.6,0l25.7-25.6a16.2,16.2,0,0,0,0-23.6Z\" transform=\"translate(-106.7)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/slider-prev.svg
// module id = 70
// module chunks = 1